import { MessagesActionType } from '@app/modules/Messages/store/actions'

const initialState = {
  chat: null,
  chatError: null,
  customer: null,
  sending: false,
  answerError: null,
  documents: [],
  documentsError: null,
  showTextAreaError: false,
  notes: '',
  letterRequestId: null,
  answerWithoutReport: {
    selectedDocuments: [],
    selectedLetterId: undefined
  },
  auditReport: {
    selectedDocuments: [],
    selectedLetterId: undefined
  },
  upgradeRequested: false
}

export default function lawyerChat(state = initialState, { type, payload }) {
  switch (type) {
    case MessagesActionType.ANSWER:
    case MessagesActionType.ANSWER_SUCCESS:
    case MessagesActionType.ANSWER_ERROR:
    case MessagesActionType.SUBMIT_AUDIT_REPORT:
    case MessagesActionType.LAWYER_DOCUMENTS_SUCCESS:
    case MessagesActionType.LAWYER_DOCUMENTS_ERROR:
    case MessagesActionType.LAWYER_DOC_UPLOAD:
    case MessagesActionType.LAWYER_DOC_UPLOAD_ERROR:
    case MessagesActionType.SHOW_ERRORS:
    case MessagesActionType.ADD_NOTES:
    case MessagesActionType.SAVE_OPEN_LETTER_REQUEST_ID:
      return { ...state, ...payload }

    case MessagesActionType.CLEAR_SELECTED_DOCS:
      return {
        ...state,
        answerWithoutReport: {
          ...state.answerWithoutReport,
          selectedDocuments: [],
          selectedLetterId: undefined
        },
        auditReport: {
          ...state.auditReport,
          selectedDocuments: [],
          selectedLetterId: undefined
        }
      }

    case MessagesActionType.ADD_SELECTED_DOC:
      return {
        ...state,
        answerWithoutReport: {
          ...state.answerWithoutReport,
          selectedDocuments: state.answerWithoutReport.selectedDocuments.concat(payload.id)
        }
      }

    case MessagesActionType.ADD_SELECTED_LETTER:
      return {
        ...state,
        answerWithoutReport: {
          ...state.answerWithoutReport,
          selectedLetterId: payload.id
        }
      }

    case MessagesActionType.REMOVE_SELECTED_DOC:
      return {
        ...state,
        answerWithoutReport: {
          ...state.answerWithoutReport,
          selectedDocuments: state.answerWithoutReport.selectedDocuments.filter(
            (item) => item !== payload.id
          )
        }
      }

    case MessagesActionType.REMOVE_SELECTED_LETTER:
      return {
        ...state,
        answerWithoutReport: {
          ...state.answerWithoutReport,
          selectedLetterId: undefined
        }
      }

    case MessagesActionType.ADD_AUDIT_SELECTED_DOC:
      return {
        ...state,
        auditReport: {
          ...state.auditReport,
          selectedDocuments: state.auditReport.selectedDocuments.concat(payload.id)
        }
      }

    case MessagesActionType.ADD_SELECTED_LETTER_TO_AUDIT:
      return {
        ...state,
        auditReport: {
          ...state.auditReport,
          selectedLetterId: payload.id
        }
      }

    case MessagesActionType.REMOVE_SELECTED_LETTER_FROM_AUDIT:
      return {
        ...state,
        auditReport: {
          ...state.auditReport,
          selectedLetterId: undefined
        }
      }

    case MessagesActionType.REMOVE_AUDIT_SELECTED_DOC:
      return {
        ...state,
        auditReport: {
          ...state.auditReport,
          selectedDocuments: state.auditReport.selectedDocuments.filter(
            (item) => item !== payload.id
          )
        }
      }

    case MessagesActionType.SAVE_AUDIT_DATA:
      return {
        ...state,
        auditReport: {
          ...state.auditReport,
          data: payload.data
        }
      }

    default:
      return state
  }
}
